import { SIDENAV_GROUP_BY, TIER } from "@/constants";

export const NEW = "NEW";
export const COMING_SOON = "COMING_SOON";

export type SideNavItemStatus = typeof NEW | typeof COMING_SOON;

export type SideNavPill = {
  variant: "info" | "warning" | "danger" | "success";
  text: string;
};

export const sideNavSectionLabelByGroup = (
  group: string,
  tier: string,
): string => {
  if (group === SIDENAV_GROUP_BY.BETA && tier !== TIER.system) {
    return "solutions";
  }
  if (group === SIDENAV_GROUP_BY.NIU && tier !== TIER.system) {
    return "partners";
  }
  return "";
};
